module.exports = function() {
  return new Worker(__webpack_public_path__ + "01727cafedcb8ea2dc93.worker.js");
};